import React, { Props } from 'react';
import { PvsCampaign, ThomasAdvertiser } from 'models/interfaces/index';
import { Link } from 'react-router-dom';
import { printDate } from 'util/dateUtils';
import './PvsCampaignView.scss';

interface PvsCampaignProps {
  campaign: PvsCampaign;
  advertiser: ThomasAdvertiser;
}

class PvsCampaignView extends React.Component<PvsCampaignProps, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const campaign = this.props.campaign;
    const advertiserName = this.props.advertiser.name;

    let startDate = new Date(campaign.start_date);
    let endDate = new Date(campaign.end_date);

    return (
      <section>
        <header>
          <h1>{advertiserName}</h1>
          <h2>{campaign.ad_server_name}</h2>
          <Link
            to={`/advertisers/${campaign.tgrams_id}/campaigns/${campaign.pvs_campaign_id}/edit`}
          >
            Edit
          </Link>
        </header>
        <section>
          <div style={{ flex: 1, flexDirection: 'column' }}>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <label className="campaign__label">Vertical:</label>
            </div>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <span className="campaign__detail">{campaign.vertical && campaign.vertical.display_name}</span>
            </div>
          </div>
          <div style={{ flex: 1, flexDirection: 'column' }}>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <label className="campaign__label">Start Date:</label>
            </div>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <span className="campaign__detail">{printDate(startDate.toISOString())}</span>
            </div>
          </div>
          <div style={{ flex: 1, flexDirection: 'column' }}>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <label className="campaign__label">End Date:</label>
            </div>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <span className="campaign__detail">{printDate(endDate.toISOString())}</span>
            </div>
          </div>
          <div style={{ flex: 1, flexDirection: 'column' }}>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <label className="campaign__label">Is Active:</label>
            </div>
            <div style={{ flex: 1, flexDirection: 'row' }}>
              <span className="campaign__detail">{campaign.is_active === true ? 'yes' : 'no'}</span>
            </div>
          </div>
        </section>
      </section>
    );
  }
}

export default PvsCampaignView;
